
module.exports = function($http, $rootScope) {
    var service = {
        clearParticipant: function() {
            delete $rootScope.participantHash;
            return $http.delete('/api/game/clear-participant');
        }
    };

    return service;
}
